import { createWebHistory, createRouter } from "vue-router";
import Login from '../components/Login.vue';
import Register from '../components/Account/Register.vue';
import Reset from '../components/Account/Reset.vue';
import Home from '../components/Home.vue';
import Navigator from '../components/Navigator.vue';
import Quote from '../components/Quote.vue';
/*
import Tennants from '../components/Tennants.vue';
import Users from '../components/Users.vue';
import Roles from '../components/Roles.vue';
import Pages from '../components/Pages.vue';
import Setup from '../components/Setup.vue';
import DataSources from '../components/DataSources.vue';
import Schemas from '../components/Schemas.vue';
import TableData from '../components/TableData.vue';
import Organisations from '../components/Organisations.vue';
import Contacts from '../components/Contacts.vue';
import Quotes from '../components/Quotes.vue';
import StatusCodes from '../components/StatusCodes.vue';
import ReasonCodes from '../components/ReasonCodes.vue';
import DataSourceFormats from '../components/DataSourceFormats.vue';
*/
var routes = [
  { path: '/', redirect: '/home'  },
  { path: '/login', component: Login, meta: { guest: true } },
  { path: '/register', component: Register, meta: { guest: true } },
  { path: '/navigator', component: Navigator },
  { path: '/quote/:id?', name: 'Quote', component: Quote },
  { path: '/reset', component: Reset, meta: { guest: true } },
  { path: '/home', component: Home }
];
/*
  { name: 'tennants', path: '/tennants', component: Tennants},
  { name: 'users', path: '/users', component: Users},
  { name: 'roles', path: '/roles', component: Roles},
  { name: 'pages', path: '/pages', component: Pages},
  { path: '/setup', component: Setup, meta: { admin: true } },
  { path: '/datasources', component: DataSources },
  { path: '/datasourceformats', component: DataSourceFormats },
  { path: '/schemas', component: Schemas },
  { name: 'tabledata', path: '/tabledata/:id', component: TableData },
  { name: 'organisations', path: '/organisations', component: Organisations },
  { name: 'contacts', path: '/contacts', component: Contacts},
  { name: 'quotes', path: '/quotes/:id?', component: Quotes },
  { name: 'statusCodes', path: '/statuscodes/:id?', component: StatusCodes },
  { name: 'reasonCodes', path: '/reasoncodes/:id?', component: ReasonCodes },
];*/

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {

  router.routeClicked = new CustomEvent('routeClicked', {});

  if(to.query && to.query.token) {
    var http = router.App.$http;
    var apiUrl = router.App.config.globalProperties.apiUrl;

    http.post(apiUrl + 'users/authenticate', { Token: to.query.token })
      .then((response) => {
        var data = response.data;

        localStorage.clear();

        if(to.query.embedded) {
          localStorage.setItem('embedded', true);
        }

        localStorage.setItem('contactId', data.ContactId);
        localStorage.setItem('acceptedQuoteId', data.AcceptedQuoteId);
        localStorage.setItem('organisationId', data.OrganisationId);
        localStorage.setItem('settings', JSON.stringify(data.Settings));
        localStorage.setItem('userToken', data.Token);
        localStorage.setItem('userEmail', data.Email);
        localStorage.setItem('userName', data.Name);
        localStorage.setItem('permissions', JSON.stringify(data.Permissions));         

        console.log(data);

        next();
      });

      return;
  }

  //console.log(to);

  if(to.matched.some(record => !(record.meta.guest))) {
   
      if (localStorage.getItem('userToken') == null) {
         
          next({
              path: '/login',
              params: { nextUrl: to.fullPath }
          })
      } else {
          //let user = JSON.parse(localStorage.getItem('user'))
          //if(to.matched.some(record => record.meta.is_admin)) {
              //if(user.is_admin == 1){
              //    next()
              //}
              //else{
              //    next({ name: 'userboard'})
              //}
          //}else {
            
            if(to.name == "New Quote") {
              var acceptedQuoteId = localStorage.getItem('acceptedQuoteId');
              if(acceptedQuoteId && acceptedQuoteId != 0) {
                next({ name: 'Quote Accepted', params: { id: acceptedQuoteId } })
              }
              else {
                next()
              }
            }
            else {
              next()
            }
      }
  } else if(to.matched.some(record => record.meta.guest)) {
      if(to.name == 'register') {
        localStorage.clear();
        next()
      }
      else if(localStorage.getItem('userToken') == null){
          next()
      }
      else{
          next({ name: 'home'})
      }
  }else {
      next()
  }
})

export default router;